<template>
  <div class="vehicleBox">
    <el-card :body-style="{ padding: '5px 10px' }">
      <el-row>
        <el-col
          :span="24"
          class="unitTitle"
        >
          <el-checkbox
            v-model="formData.isHanding"
            true-label="1"
            false-label="0"
          >
            {{ parentData.title }}
          </el-checkbox>
        </el-col>
      </el-row>

      <el-form
        ref="refVehicleForm"
        :model="formData"
        label-width="0px"
        :rules="vehicleRules"
      >
        <el-form-item>
          <el-row
            :gutter="10"
            type="flex"
            align="middle"
          >
            <el-col :span="11">
              <vxe-table
                ref="xTable"
                row-id="vehicleId"
                size="small"
                border
                show-overflow
                keep-source
                :data="parentData.tableData"
                :edit-config="{ trigger: 'click', mode: 'row' }"
                @edit-closed="saveEvent"
              >
                <vxe-table-column
                  field="price"
                  title="费用"
                  :edit-render="{name: '$input', props: {type: 'number', min:'0', max:'999999'}}"
                />
                <vxe-table-column
                  field="limitEnd"
                  title="范围"
                  :edit-render="{name: '$input', props: {type: 'number', min:'0', max:'999999'}}"
                />
              </vxe-table>
            </el-col>
            <el-col
              :span="1"
              class="iconCount"
            >
              <i class="el-icon-plus" />
            </el-col>
            <el-col
              :span="7"
              class="contentBox"
            >
              <!-- 公里单价 -->
              <el-col :span="9">
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="公里单价"
                  placement="top"
                >
                  <el-form-item
                    label-width="0"
                    prop="unitPrice"
                  >
                    <el-input
                      v-model.number="formData.unitPrice"
                      placeholder="公里单价"
                      min="0.00"
                      step="0.01"
                      @input="(value)=>formFormatter.isFloor2(value,oldValue,formData,'unitPrice')"
                    >
                      <i slot="suffix">元/Km</i>
                    </el-input>
                  </el-form-item>
                </el-tooltip>
              </el-col>
              <el-col
                :span="2"
                class="iconCount"
              >
                <i class="el-icon-close" />
              </el-col>
              <el-col
                :span="13"
                class="contentBox"
              >
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="超出公里数"
                  placement="top"
                >
                  <el-form-item label-width="0">
                    <el-input
                      placeholder="公里数-起步公里数"
                      disabled
                    >
                      <i slot="suffix">Km</i>
                    </el-input>
                  </el-form-item>
                </el-tooltip>
              </el-col>
            </el-col>
            <el-col
              :span="1"
              class="iconCount"
            >
              <i>=</i>
            </el-col>
            <el-col
              :span="4"
              class="contentBox"
            >
              <el-col :span="24">
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="包车运费"
                  placement="top"
                >
                  <el-form-item label-width="0">
                    <el-input
                      placeholder="包车运费"
                      disabled
                    >
                      <i slot="suffix">元</i>
                    </el-input>
                  </el-form-item>
                </el-tooltip>
              </el-col>
            </el-col>
          </el-row>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import request from '@/utils/request'
export default {
  name: "VehiclePrice",
  props: {
    parentData: {
      type: Object,
      default() {
        return {
          tableData:[]
        };
      }
    }
  },
  data() {
    return {
      priceWidth: 22,
      isRemove: false,
      dictData: [],
      vehicleData: [],
      vehicleRules: {
        points: [{ type: "number", message: "百分比必须为数字值" }]
      },
      formData: {
        tableData: [
          { price: 10, limitEnd: 20 },
          { price: 50, limitEnd: 80 },
          { price: 100, limitEnd: 160 }
        ],
        unitPrice: "",
        domains: [
          {
            routelineCode: "",
            vehicleOptions: this.vehicleData,
            points: ""
          }
        ]
      }
    };
  },

  created() {},
  mounted() {
    // this.getVehicleType();
  },
  methods: {
    getVehicleType() {
      request({
        url: "/ntocc-basic-api/dict/listDict",
        method: "get",
        params: { types: "vehicleClassification" }
      }).then(response => {
        this.dictData = response.data[0].dictList;
        this.dictData.map(item => {
          this.vehicleData.push(
            Object.assign({}, { value: item.code, label: item.name })
          );
        });
        this.formData.domains[0].vehicleOptions = this.vehicleData;
      });
    },
    addCarPrice() {
      this.formData.domains.push({
        key: Date.now(),

        routelineCode: "",
        vehicleOptions: this.vehicleData,
        points: ""
      });
      this.priceWidth = 19;
      this.isRemove = true;
    },
    // 删除当前包车价格
    removeCarPrice(item) {
      var delId;
      this.formData.domains.map((val, index) => {
        if (val.key == item.key) {
          delId = index;
        }
      });
      if (this.formData.domains.length > 1) {
        this.formData.domains.splice(delId, 1);
      } else {
        this.priceWidth = 22;
        this.isRemove = false;
        this.$refs.refVehicleForm.resetFields();
      }
    },
    resetVehicleForm() {
      this.$refs.refVehicleForm.resetFields();
      this.formData.domains.splice(1);
      this.formData.tableData = [
        { price: 10, limitEnd: 20 },
        { price: 50, limitEnd: 80 },
        { price: 100, limitEnd: 160 }
      ];
    },
    // 编辑结束
    saveEvent(){

    }
  }
};
</script>
<style lang="scss" scoped>
.el-card {
  margin-bottom: 10px;
}
.iconCount {
  text-align: center;
}
.unitTitle {
  font-size: 14px;
  font-weight: 700;
  color: #606266;
  line-height: 36px;
}
</style>
